import { IconClockFilled, IconMapPinFilled } from "@tabler/icons-react";
import classNames from "classnames";
import { m, MotionProps } from "framer-motion";
import { JSX, PropsWithoutRef } from "react";

export type NotificationProps = Overwrite<Overwrite<PropsWithoutRef<JSX.IntrinsicElements["div"]>, MotionProps>, {
  mapIncident: HydratedMapIncident;
}>;

export default function Notification({ className, mapIncident, ...props }: NotificationProps) {
  return (
    <m.div
      {...props}
      className={classNames(
        "bg-body bg-opacity-75 backdrop-blur-2px border-0 card rounded-4 shadow-lg text-nowrap",
        className,
      )}
    >
      <div className="align-items-center card-body d-flex gap-12">
        <div className="overflow-hidden">
          <div className="text-truncate">
            <div className="fs-8 fw-semi-bold text-body-tertiary">Cause</div>

            <div className="fw-semi-bold">{mapIncident.detail}</div>
          </div>

          <div className="align-items-center d-flex fs-8 fw-semi-bold gap-4 mt-2">
            <div className="align-items-center d-flex gap-1 text-body-tertiary">
              <IconClockFilled size="1em" />

              <span>{mapIncident.dateTimeDayjs.format("LT")}</span>
            </div>

            <div className="align-items-center d-flex gap-1 text-body-tertiary">
              <IconMapPinFilled size="1em" />

              {mapIncident.country !== null ? (
                <>
                  {mapIncident.city !== null ? `${mapIncident.city}, ` : null}
                  {mapIncident.country}
                </>
              ) : "N/A"}
            </div>
          </div>
        </div>

        <div
          className={classNames(
            "flex-shrink-0 rounded-circle size-1_5rem",
            mapIncident.latitude !== null && mapIncident.longitude !== null ? "bg-warning" : "bg-transparent",
          )}
        />

      </div>
    </m.div>
  );
}
